import { Label } from 'semantic-ui-react';

export const DigestStatusLabel = ({ digest }) => {
  if (digest.isSent) return <Label content="Sent" color="blue" size="tiny" />;
  if (!digest.sendTime) return <Label content="Draft" color="yellow" size="tiny" />;
  if (!digest.isScheduled) return <Label content="Draft" color="yellow" size="tiny" />;
  // if (!digest.isSent) return <Label content="Draft" color="yellow" size="tiny" />;
  return <Label content="Scheduled" color="green" size="tiny" />;
};

export const PromoStatusLabel = ({ digest }) => {
  if (digest.isScheduled) return <Label content="Scheduled" color="green" size="tiny" />;
  if (digest.isSent && digest.sendTime) return <Label content="Sent" color="blue" size="tiny" />;
  if (!digest.isSent) return <Label content="Draft" color="yellow" size="tiny" />;
  // if (!digest.isSent) return <Label content="Draft" color="yellow" size="tiny" />;
  return <Label content="Draft" color="yellow" size="tiny" />;
};

export default DigestStatusLabel;
